import React from "react";
import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import { StyledBreakWord } from "../../../styles/styledBreakWord";

import { StyledCol, StyledTableRow } from "../../../styles/styledTable";

const MasterBalancesHistoryItem = ({ value }) => {

  return (
    <StyledTableRow
      scroll="auto"
      col="5"
    >
      <StyledCol>
        {value.amount > 0 ? "+" + value.amount : value.amount}
      </StyledCol>
      <StyledCol inline>
        <StyledBreakWord as="p">
          {value.user}
        </StyledBreakWord>
      </StyledCol>
      <StyledCol>
        {value.operationType}
      </StyledCol>
      <StyledCol>
        {value.operationId}
      </StyledCol>
      <StyledCol>
        {TimestampToDateMoment(value.createdAt / 1000)}
      </StyledCol>
    </StyledTableRow>
  );
};

export default MasterBalancesHistoryItem;